import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from '@react-pdf/renderer'

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  mainView: {
    width: '100%',
    margin: '11.8mm 8mm',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  qrSection: {
    width: '40mm',
    height: '40mm',
    marginBottom: '2.9mm',
    marginTop: '2.9mm',
    marginLeft: '2mm',
    marginRight: '3.25mm',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  qrImage: {
    width: '36mm',
    height: '36mm',
  },
})

export const QRCodeDocument = ({ dataUrls }: { dataUrls: string[] }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.mainView}>
          {dataUrls.map((dataUrl) => (
            <View key={dataUrl} style={styles.qrSection}>
              {/* eslint-disable-next-line jsx-a11y/alt-text */}
              <Image
                key={`image_${dataUrl}`}
                src={dataUrl}
                style={styles.qrImage}
              />
              <Text
                style={{
                  fontSize: '6px',
                  marginTop: '0px',
                }}
              >
                Skop
              </Text>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  )
}
